import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const CreateNewConfigurationHeaderStyled = styled(Box).attrs({
  pl: { sm: '500' },
  py: { sm: '100' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  background: ${({ theme }) => theme.colors.primary[700]};
`;
export const FooterStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
  justifyContent: { sm: 'flex-end' },
  gap: { sm: '500' },
})`
  width: 99%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadowInverted};
  position: absolute;
  bottom: 8px;
`;
